import { render, staticRenderFns } from "./CertificateTool.vue?vue&type=template&id=54bd2b83&scoped=true&"
import script from "./CertificateTool.vue?vue&type=script&lang=js&"
export * from "./CertificateTool.vue?vue&type=script&lang=js&"
import style0 from "./CertificateTool.vue?vue&type=style&index=0&id=54bd2b83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd2b83",
  null
  
)

export default component.exports